var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 8.000000)",
    stroke: "#A4B1CD",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "hyperlink"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,6 C13.5,7.1045695 14.3954305,8 15.5,8 L20.5,8 C22.15503,7.99560415 23.4956041,6.65503001 23.5,5 L23.5,3 C23.4950578,1.3451972 22.1548028,0.00494220167 20.5,0 L15.5,0 C14.3954305,0 13.5,0.8954305 13.5,2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,6 C10.5,7.1045695 9.6045695,8 8.5,8 L3.5,8 C1.84496999,7.99560415 0.504395853,6.65503001 0.5,5 L0.5,3 C0.504942202,1.3451972 1.8451972,0.00494220167 3.5,0 L8.5,0 C9.6045695,0 10.5,0.8954305 10.5,2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 3.999,
    x2: 17.5,
    y2: 3.999,
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.5da070dd0264b406f0d8139f22a5fb47.svg";
export { ForwardRef as ReactComponent };